/** @format */
/* eslint @typescript-eslint/dot-notation: "warn" */

function responseRejected(error: any) {
    // Get the first validation message for each form field
    if (error?.response?.data?.data?.errors) {
        error['validationErrors'] = {};
        Object.keys(error.response.data.data.errors).map((fieldName) => {
            error.validationErrors[fieldName] =
                error.response.data.data.errors[fieldName][0];
        });
    }
    return Promise.reject(error);
}

export const validationMessagesInterceptor = {
    responseRejected,
};
